import { API_BASE } from '../../constants'
import { FetchPolicyError, fetchWithPolicy } from '../../../shared/api/fetchPolicy'

export const requestCatalogJson = async <T>({
  path,
  signal,
  fallbackError,
  notFoundError,
}: {
  path: string
  signal: AbortSignal
  fallbackError: string
  notFoundError?: string
}): Promise<T> => {
  let response: Response
  try {
    response = await fetchWithPolicy({
      request: `${API_BASE}${path}`,
      init: { signal },
    })
  } catch (error) {
    if (error instanceof FetchPolicyError) {
      throw new Error(fallbackError, { cause: error })
    }
    throw error
  }
  if (!response.ok) {
    // Callers can opt into domain-specific 404 messages while sharing one transport helper.
    if (response.status === 404 && notFoundError) {
      throw new Error(notFoundError)
    }
    throw new Error(fallbackError)
  }
  return (await response.json()) as T
}

export const toRecordArray = (value: unknown): Record<string, unknown>[] =>
  Array.isArray(value)
    ? value.filter((entry): entry is Record<string, unknown> => Boolean(entry) && typeof entry === 'object')
    : []

export const toRequiredRecord = (value: unknown, message: string): Record<string, unknown> => {
  if (!value || typeof value !== 'object') {
    throw new Error(message)
  }
  return value as Record<string, unknown>
}
